// src/auth/initAuth.js
import axios from 'axios'
import config from '@/config.json'
import {
    getRefreshToken,
    setAccessToken,
    clearTokens,
    getStoredPermissions,
    getStoredUsername
} from '@/utils/token'
import { setAuthState, resetAuthState } from './index'

export async function initAuth() {
    const refresh = getRefreshToken()

    if (!refresh) {
        resetAuthState()
        return
    }

    try {
        // 用 refresh 換 access
        const res = await axios.post(
            `${config.apiBaseUrl}/api/annotations/token/refresh`,
            { refresh }
        )

        const newAccess = res.data.access
        setAccessToken(newAccess)

        // 從 localStorage 還原權限 & 使用者名稱
        const permissions = getStoredPermissions()
        const username = getStoredUsername()

        // 如果沒有權限資訊，視同沒登入，避免異常狀態
        if (!permissions) {
            clearTokens()
            resetAuthState()
            return
        }

        setAuthState({
            username,
            permissions
        })
    } catch (e) {
        console.warn('Failed to initialize auth state:', e)
        clearTokens()
        resetAuthState()
    }
}
